import Navbar from './comp/Navbar';
import {
    createHashRouter,
    RouterProvider,
    Outlet,
} from "react-router-dom";
import './App.css';
import Homepage from './pg/Homepage';
import Contact from './pg/Contact';
import Footer from './comp/Footer';
import Projects from './pg/Projects';
import { LangSwitchButton } from './comp/chooseLang/ChooseLang';
import MarkdownView from './comp/Markdown';
import B3Page from './pg/B3';
import Warehouse from './pg/Warehous';
import Raycaster from './pg/Ascii';

function Layout() {
    return (
        <div>
            <LangSwitchButton Langs={['en', 'pl']} />
            <Navbar />
            <Outlet />
            <Footer socials={['https://github.com/1mb33']} links={[
                ['#/', '/home'],
                ['/#projects', '/projects'],
                ['/#contact', '/contact']
            ]} contact={['contact.mateuszgola@gmail.com', '+48 798 606 652']} />
        </div>
    );
}

const router = createHashRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            { index: true, element: <Homepage /> },
            { path: "projects", element: <Projects /> },
            { path: "projects/b3", element: <B3Page/> },
            { path: "projects/warehouse", element: <Warehouse /> },
            { path: "projects/raycaster", element: <Raycaster /> },
            { path: "contact", element: <Contact /> },
        ],
    },
]);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
